Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Federated", {
    enumerable: true,
    get: function() {
        return Federated;
    }
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _ScriptManager = require("./ScriptManager.js");
var Federated;
(function(_Federated) {
    /**
   * @deprecated
   *
   * Resolves URL to a container or a chunk when using Module Federation,
   * based on given `scriptId` and `caller`.
   */ /**
   * @deprecated
   *
   * Configuration options for {@link createURLResolver} for Module Federation.
   * Allows to configure how created {@link URLResolver} will behave.
   */ /**
   * @deprecated
   *
   * Creates URL resolver for Module Federation from provided config.
   *
   * @example
   * ```ts
   * import { ScriptManager, Script, Federated } from '@callstack/repack/client';
   *
   * const resolveURL = Federated.createURLResolver({
   *   containers: {
   *     app1: 'http://localhost:9001/[name][ext]',
   *     app2: 'http://localhost:9002/[name].container.js',
   *   },
   *   chunks: {
   *     app2: 'http://localhost:9002/chunks/[name][ext]',
   *   },
   * });
   *
   * ScriptManager.shared.addResolver(async (scriptId, caller) => {
   *   let url;
   *   if (caller === 'main') {
   *     url = __DEV__
   *       ? Script.getDevServerURL(scriptId)
   *       : Script.getRemoteURL(`http://localhost:9000/${scriptId}`);
   *   } else {
   *     url = resolveURL(scriptId, caller);
   *   }
   *
   *   if (!url) {
   *     return undefined;
   *   }
   *
   *   return {
   *     url,
   *     query: {
   *       platform: Platform.OS,
   *     },
   *   };
   * });
   * ```
   *
   * `createURLResolver` is a abstraction over {@link Script.getRemoteURL},
   * for example:
   * ```ts
   * import { ScriptManager, Federated } from '@callstack/repack/client';
   *
   * ScriptManager.shared.addResolver((scriptId, caller) => {
   *   const resolveURL = Federated.createURLResolver({
   *     containers: {
   *       app1: 'http://localhost:9000/[name][ext]',
   *     },
   *   });
   *
   *   return {
   *     url: resolveURL(scriptId, caller);
   *   };
   * });
   * ```
   * is equivalent to:
   * ```ts
   * import { ScriptManager, Script } from '@callstack/repack/client';
   *
   * ScriptManager.shared.addResolver(async (scriptId, caller) => {
   *   if (scriptId === 'app1') {
   *     return {
   *       url: 'http://localhost:9000/app1.container.bundle',
   *     };
   *   }
   *
   *   if (caller === 'app1') {
   *     return {
   *       url: Script.getRemoteURL(`http://localhost:9000/${scriptId}`),
   *     };
   *   }
   * });
   * ```
   *
   * @param config Configuration for the resolver.
   * @param containerExt Extension of container bundles. Defaults to `.container.bundle`.
   * @returns A resolver function which will try to resolve URL based on given `scriptId` and `caller`.
   */ function createURLResolver(config) {
        var _loop = function(key) {
            resolvers[key] = (scriptId, caller)=>{
                if (scriptId === key) {
                    var url = config.containers[key].replace(/\[name\]/g, scriptId).replace(/\[ext\]/g, containerExt);
                    return url;
                }
                if (caller === key) {
                    var _config_chunks;
                    var url1 = (((_config_chunks = config.chunks) === null || _config_chunks === void 0 ? void 0 : _config_chunks[key]) ?? config.containers[key]).replace(/\[name\]/g, scriptId);
                    if (url1.includes('[ext]')) {
                        return (webpackContext)=>webpackContext.u(url1.replace(/\[ext\]/g, ''));
                    }
                    return url1;
                }
                return undefined;
            };
        };
        var containerExt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '.container.bundle';
        var resolvers = {};
        for(var key in config.containers)_loop(key);
        return (scriptId, caller)=>{
            var resolver = (caller ? resolvers[caller] : undefined) ?? resolvers[scriptId];
            return resolver(scriptId, caller);
        };
    }
    _Federated.createURLResolver = createURLResolver;
    /**
   * @deprecated
   *
   * Dynamically imports module from a Module Federation container. Similar to `import('file')`, but
   * specific to Module Federation. Calling `importModule` will create an async boundary.
   *
   * Container will be evaluated only once. If you use `importModule` for the same container twice,
   * the container will be loaded and evaluated only on the first import.
   *
   * Under the hood, `importModule` will call `ScriptManager.shared.loadScript(containerName)`.
   * This means, a resolver must be added with `ScriptManager.shared.addResolver(...)` beforehand and provided proper
   * resolution logic to resolve URL based on the `containerName`.
   *
   * @param containerName Name of the container - should be the same name provided to
   * `webpack.container.ModuleFederationPlugin` in `library.name`.
   * @param module Full name with extension of the module to import from the container - only modules
   * exposed in `exposes` in `webpack.container.ModuleFederationPlugin` can be used.
   * @param scope Optional, scope for sharing modules between containers. Defaults to `'default'`.
   * @returns Exports of given `module` from given container.
   *
   * @example
   * ```ts
   * import * as React from 'react';
   * import { Federated } from '@callstack/repack/client';
   *
   * const Button = React.lazy(() => Federated.importModule('my-components', './Button.js'));
   *
   * const myUtil = await Federated.importModule('my-lib', './myUtil.js');
   * ```
   */ function importModule(containerName, module) {
        var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'default';
        return _async_to_generator._(function*() {
            var __webpack_share_scopes___scope;
            if (!((__webpack_share_scopes___scope = __webpack_share_scopes__[scope]) === null || __webpack_share_scopes___scope === void 0 ? void 0 : __webpack_share_scopes___scope.__isInitialized)) {
                // Initializes the share scope.
                // This fills it with known provided modules from this build and all remotes.
                yield __webpack_init_sharing__(scope);
                __webpack_share_scopes__[scope].__isInitialized = true;
            }
            // Do not use `const container = self[containerName];` here. Once container is loaded
            // `container` reference is not updated, so `container.__isInitialized`
            // will crash the application, because of reading property from `undefined`.
            if (!self[containerName]) {
                // Download and execute container
                yield _ScriptManager.ScriptManager.shared.loadScript(containerName);
            }
            var container = self[containerName];
            if (!container.__isInitialized) {
                container.__isInitialized = true;
                // Initialize the container, it may provide shared modules
                yield container.init(__webpack_share_scopes__[scope]);
            }
            var factory = yield container.get(module);
            var exports1 = factory();
            return exports1;
        })();
    }
    _Federated.importModule = importModule;
})(Federated || (Federated = {}));
